<template>
  <div class="tw-p-0">
    <div class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-whitespace-nowrap" style="background-color: rgb(238, 238, 238);">
      <div class="tw-text-2xl tw-flex-grow tw-overflow-x-hidden tw-text-ellipsis tw-overflow-hidden">
        <router-link :to="'/people/'+person.id" class="tw-font-bold">{{ person.attributes.name }}</router-link>
        <span v-if="person.attributes.title">&nbsp;&middot;&nbsp;{{ person.attributes.title }}</span>
      </div>

      <div class="tw-flex tw-space-x-8 tw-pl-8">
        <div>
          <i v-if="person.attributes.has_partner_access" v-tooltip="'Partner access'" class="fa fa-door-open"/>
          <i v-if="person.attributes.is_advertising_contact" v-tooltip="'Advertising contact'" class="fa fa-bullhorn"/>
          <i v-if="person.attributes.is_subscription_contact" v-tooltip="'Subscription contact'" class="fa fa-book-reader"/>
        </div>

        <div>
          <button type="button" class="tw-bg-transparent tw-border-0 tw-w-8" @click="expanded = !expanded"><i class="fa" :class="expanded ? 'fa-chevron-down':'fa-chevron-right'"/></button>

          <div class="btn-group">
            <button type="button" class="tw-bg-transparent tw-border-0 tw-w-8 dropdown-toggle" data-toggle="dropdown" style="box-shadow: none"><i class="fa fa-ellipsis-v"/></button>

            <ul class="dropdown-menu">
              <li>
                <a :data-target="'.create-mail-subscription-modal[data-person-id='+person.id+']'" data-toggle="modal">
                  <i class="fa fa-envelope"></i> Subscribe
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div v-if="expanded">
      <div class="tw-flex tw-items-center tw-justify-center tw-space-x-4 tw-px-6 tw-py-4">
        <div v-for="method in getContactMethods(person)">
          <i class="fa" :class="method.icon"/>&nbsp;<a :href="method.href">{{ method.text }}</a>
        </div>
      </div>

      <LoadingSpinner v-if="loading"/>

      <div v-for="mailSubscription in mailSubscriptions" class="tw-flex tw-px-6 tw-py-2 tw-border-b-2 tw-border-blue-900" style="border-top: 1px solid rgb(229, 231, 235)">
        <div class="tw-flex-grow">
          {{ mailSubscription.list_name }}

          <span v-for="n in mailSubscription.rating">
            <i class="fa fa-star"/>
          </span>
        </div>

        <div>
          <button type="button" class="tw-bg-transparent tw-border-0 tw-w-8" @click="destroyMailSubscription(mailSubscription)"><i class="fa fa-trash"/></button>
        </div>
      </div>
    </div>

    <CreateMailSubscriptionModal :person="person" @created="mailSubscriptions.push(format($event))"/>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import CreateMailSubscriptionModal from "../Modals/CreateMailSubscriptionModal.vue";

export default {
  components: {CreateMailSubscriptionModal, LoadingSpinner},

  props: {
    person: {
      required: true,
      type: Object
    },

    mailingLists: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      mailSubscriptions: null,

      expanded: false,
      loading: true,
      loaded: false,
    }
  },


  methods: {
    load() {
      this.loaded = true

      http
          .get('/api/v2/external/mail-subscriptions', {'filter[email]': this.person.attributes.email})
          .then(response => {
            this.mailSubscriptions = response.data.data.map(row => this.format(row))

            this.loading = false
          })
    },

    format(mailSubscription) {
      return {
        id: mailSubscription.id,
        ...mailSubscription.attributes,
        list_name: this.mailingLists.find(mailingList => mailingList.id === mailSubscription.attributes.list_id).attributes.name,
      }
    },

    getContactMethods(person) {
      let methods = []

      if (person.attributes.email) {
        methods.push({
          icon: 'fa-envelope',
          href: 'mailto:' + person.attributes.email,
          text: person.attributes.email
        })
      }

      if (person.attributes.cell_phone) {
        methods.push({
          icon: 'fa-mobile',
          href: 'tel:' + person.attributes.cell_phone,
          text: person.attributes.cell_phone
        })
      }

      if (person.attributes.work_phone) {
        methods.push({
          icon: 'fa-phone',
          href: 'tel:' + person.attributes.work_phone,
          text: person.attributes.work_phone
        })
      }

      return methods
    },

    destroyMailSubscription(mailSubscription) {
      modal.confirm('Are you sure that you want to remove the mail subscription?', () => {
        http.delete('/api/v2/external/mail-subscriptions/' + mailSubscription.list_id + '/' + mailSubscription.id)
            .then(() => {
              notify.success('The subscription was removed')

              this.mailSubscriptions.splice(this.mailSubscriptions.findIndex(existing => existing.id === mailSubscription.id && existing.list_id === mailSubscription.list_id), 1)
            })
            .catch(error => {
              if (error.response.status === 400) {
                return notify.error(error.response.data.message)
              }

              throw error
            })
      })
    }

  },

  watch: {
    expanded() {
      if (!this.loaded) {
        this.load()
      }
    }
  }
}
</script>
